import { render, staticRenderFns } from "./MediaAliasEditor.vue?vue&type=template&id=189e13b4&scoped=true"
import script from "./MediaAliasEditor.vue?vue&type=script&lang=ts"
export * from "./MediaAliasEditor.vue?vue&type=script&lang=ts"
import style0 from "./MediaAliasEditor.vue?vue&type=style&index=0&id=189e13b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "189e13b4",
  null
  
)

export default component.exports